import * as tslib_1 from "tslib";
var CODE = 'ExpiredPasswordSoon';
var ExpiredPasswordSoonError = /** @class */ (function (_super) {
    tslib_1.__extends(ExpiredPasswordSoonError, _super);
    function ExpiredPasswordSoonError(response) {
        var _this = _super.call(this, CODE) || this;
        _this['error'] = {
            code: CODE,
            response: response
        };
        return _this;
    }
    return ExpiredPasswordSoonError;
}(Error));
export { ExpiredPasswordSoonError };
